import { render, staticRenderFns } from "./DesktopTopMenu.vue?vue&type=template&id=0771370c"
import script from "./DesktopTopMenu.vue?vue&type=script&lang=js"
export * from "./DesktopTopMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports